<template>
  <div class="devData">
  <div class="manage-header">
      <div><h3>{{$store.state.module1.isChina?'设备管理':'device management'}}</h3><span v-if="arealist">{{proDevNum}}{{$store.state.module1.isChina?'个设备':''}}</span></div>
      <div style="position:relative;"><input type="text" :placeholder="$store.state.module1.isChina?'请输入场所名称':'Enter place name'" v-model="word" @input="searchWord"><i class="el-icon-search"></i></div>
  </div>
    <div class="section6 Radius">
      <comBox>
      <template v-slot:name><h3>{{$store.state.module1.isChina?'设备列表':'device list'}}</h3></template>
      <template v-slot:other>
        <el-button type="primary" @click="openAddDev" size="small">{{$store.state.module1.isChina?'添加设备':'add device'}}</el-button>
        <el-button type="primary" plain size="small" @click="qwer()">{{choseAll?$store.state.module1.isChina?'取消':'cancel':$store.state.module1.isChina?'批量操作':'Batch operation'}}</el-button>
      </template>
      <template v-slot:content>
      <div class="section2">
      <div class="choseAll" v-show="choseAll">
        <span class="have">{{choseDev.length}}</span>
        <span><span @click="d()">{{$store.state.module1.isChina?'下载':'download'}}</span>|<span @click="deleteAll()">{{$store.state.module1.isChina?'删除':'delete'}}</span><span @click="toggleSelection()">{{$store.state.module1.isChina?'清空':'empty'}}</span></span>
      </div>
      <div>
        <el-table ref="multipleTable" :data="arealist" style="width: 100%;marginTop:0.2rem;" @selection-change="handleSelection">
        <el-table-column type="selection" :width="width*0.2" v-if="choseAll">
         </el-table-column>
        <el-table-column :label="$store.state.module1.isChina?'设备种类':'type'" :width="width*0.8"><template slot-scope="scope">
            <p class="qwe">{{ scope.row.typename }}</p>
        </template></el-table-column>
        <el-table-column :label="$store.state.module1.isChina?'设备品牌':'brand'" :width="width*0.6" >
          <template slot-scope="scope">
            <p class="qwe">{{ scope.row.brandname }}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$store.state.module1.isChina?'设备型号':'model'" :width="width*0.6"  >
          <template slot-scope="scope">
            <p class="qwe">{{ scope.row.model }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="ren" :label="$store.state.module1.isChina?'设备SN号':'SN number'" :width="width">
          <template slot-scope="scope">
           <p class="qwe">{{scope.row.code}}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$store.state.module1.isChina?'设备名称':'name'" :width="width"><template slot-scope="scope">
            <p class="qwe">{{ scope.row.dname }}</p>
        </template></el-table-column>
        <!-- 无线网
        <el-table-column prop="num" :label="$store.state.module1.isChina?'WIFI地址':'WIFI'"  :width="width">
          <template slot-scope="scope">
           <p class="qwe">{{scope.row.wifi_address}}</p>
          </template>
         </el-table-column>
         -->
        <el-table-column prop="devNum" :label="$store.state.module1.isChina?'所属区域':'Region'"  :width="width">
          <template slot-scope="scope">
           <p class="qwe">
             {{scope.row.areaname}}
             </p>
          </template>
        </el-table-column>
        <el-table-column prop="devNum" :label="$store.state.module1.isChina?'设备状态':'status'"  :width="width*0.8">
          <template slot-scope="scope">
           <p class="qwe">
             {{scope.row.state}}
             </p>
          </template>
        </el-table-column>
         <el-table-column :label="$store.state.module1.isChina?'创建时间':'create time'"  :width="width">
           <template slot-scope="scope">
           <p class="qwe">{{scope.row.create_time.slice(0,10)}}<br/>{{scope.row.create_time.slice(11)}}</p>
          </template>
         </el-table-column>
         <el-table-column :label="$store.state.module1.isChina?'更新时间':'Update time'" :width="width">
           <template slot-scope="scope">
           <p class="qwe" v-if="scope.row.update_time">{{scope.row.update_time.slice(0,10)}}<br/>{{scope.row.update_time.slice(11)}}</p>
           <p class="qwe" v-else>{{$store.state.module1.isChina?'暂无更新':'null'}}</p>
          </template>
         </el-table-column>
         <el-table-column :label="$store.state.module1.isChina?'操作':'operation'"  :width="width">
           <template slot-scope="scope"  v-if="!choseAll"  >
            <p class="qwe">
            <i class="el-icon-edit" style="cursor:pointer"  :title="$store.state.module1.isChina?'编辑':'edit'" @click="editDev(scope.row)"></i>
            <i class="el-icon-download" style="cursor:pointer"  :title="$store.state.module1.isChina?'下载':'download'" @click="downOne(scope.row)"></i>
            <i class="el-icon-delete" style="cursor:pointer"  :title="$store.state.module1.isChina?'删除':'delete'" @click="deleteDe(scope.row)"></i>
            <span style="color:#11D080;cursor:pointer" v-show="bindXf" @click="dobind(scope.row.code)">{{$store.state.module1.isChina?'绑定':'bind'}}</span>
          </p>
          </template>
         </el-table-column>
      </el-table>
      </div>
      <div class="myPage">
        <el-pagination layout="prev, pager, next, jumper" :total="proDevNum" background @current-change="changePage" :current-page="currentPage" :page-size="8">
        </el-pagination>
      </div>
    </div>
      </template>
    </comBox>
    </div>
    <el-dialog :title="dialogFormType===1?$store.state.module1.isChina?'新增设备':'Add device':$store.state.module1.isChina?'编辑设备':'Edit device'" :visible.sync="dialogFormVisible" width="40%" >
       <el-form label-position="left">
         <el-form-item :label="$store.state.module1.isChina?'设备名称':'device name'" :label-width="formLabelWidth">
           <el-input auto-complete="off" v-model="devName"></el-input>
         </el-form-item>
         <el-form-item :label="$store.state.module1.isChina?'设备识别号':'identification Num'" :label-width="formLabelWidth">
           <el-input auto-complete="off" v-model="devCode" v-if="dialogFormType===1"></el-input>
           <span v-else>{{devCode}}</span>
         </el-form-item>
         <!-- 无线网
         <el-form-item :label="$store.state.module1.isChina?'无线网地址':'WIFI'" :label-width="formLabelWidth">
           <el-input auto-complete="off" v-model="devWifi"></el-input>
         </el-form-item>
         -->
         <el-form-item :label="$store.state.module1.isChina?'设备排序号':'Sort Num'" :label-width="formLabelWidth">
           <el-input auto-complete="off" v-model="sort" placeholder="设置1-99以便设备按照您的顺序显示"></el-input>
         </el-form-item>
         <el-form-item :label="$store.state.module1.isChina?'设备类型':'type'" :label-width="formLabelWidth">
           <el-radio :disabled="dialogFormType!==1" v-model="typeId" :label="devType" v-for="devType in DeviceType" :key="devType.id">{{devType.name}}</el-radio>
         </el-form-item>
         <el-form-item :label="$store.state.module1.isChina?'品牌':'brand'" :label-width="formLabelWidth">
           <el-select v-model="typeId.brand" disabled>
             <el-option :label="typeId.brand" :value="typeId.brand"></el-option>
           </el-select>
         </el-form-item>
         <el-form-item :label="$store.state.module1.isChina?'型号':'model'" :label-width="formLabelWidth">
           <el-select v-model="typeId.model" disabled>
             <el-option :label="typeId.model" :value="typeId.model"></el-option>
           </el-select>
         </el-form-item>
         <el-form-item :label="$store.state.module1.isChina?'选择场所':'Choose place'" :label-width="formLabelWidth">
           <template>
            <el-select v-model="areaId" placeholder="请选择">
              <el-option
                v-for="item in proAreaList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            </template>
         </el-form-item>
       </el-form>
       <div slot="footer" class="dialog-footer">
         <el-button @click="dialogFormVisible = false">{{$store.state.module1.isChina?'取消':'Cancel'}}</el-button>
         <el-button type="primary" @click="addDev">{{$store.state.module1.isChina?'确定':'OK'}}</el-button>
       </div>
    </el-dialog>
    <!-- 数据下载弹窗 -->
    <el-dialog :title="$store.state.module1.isChina?'数据下载':'Data download'" :visible.sync="dataDown" width="480px" >
       <el-form label-position="left">
         <el-form-item :label="$store.state.module1.isChina?'设备名称':'device name'" :label-width="formLabelWidth">
           <span v-for="(dev, index) in choseDev" :key="index" style="marginRight:0.1rem;">{{dev.code}}</span>
         </el-form-item>
         <el-form-item :label="$store.state.module1.isChina?'时间区间':'time'" :label-width="formLabelWidth">
           <el-date-picker v-model="timeValue" type="daterange"
            :range-separator="$store.state.module1.isChina?'至':'To'"
            :start-placeholder="$store.state.module1.isChina?'开始日期':'start'"
            :end-placeholder="$store.state.module1.isChina?'结束日期':'end'">
            </el-date-picker>
         </el-form-item>
         <el-form-item :label="$store.state.module1.isChina?'时间类型':'time type'" :label-width="formLabelWidth">
           <template>
            <el-select v-model="timeType" :placeholder="$store.state.module1.isChina?'请选择':'select'">
              <el-option
                v-for="item in timeTypes"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
            </template>
         </el-form-item>
       </el-form>
       <div slot="footer" class="dialog-footer">
         <el-button @click="dataDown = false">{{$store.state.module1.isChina?'取消':'Cancel'}}</el-button>
         <el-button type="primary" @click="downloadall()">{{$store.state.module1.isChina?'确定':'OK'}}</el-button>
       </div>
    </el-dialog>
  </div>
</template>

<script>
import comBox from '../../../components/comBox/comBox.vue'
import { stringTime, requestData } from '../../../assets/js/commont.js'
import { Mixin } from '../../../mixins/index.js'
export default {
  name: 'devData',
  mixins: [Mixin],
  inject: ['reToken'],
  components: {
    comBox
  },
  data () {
    return {
      width: 140,
      bindXf: false,
      dataDown: false,
      upD: false,
      timeType: 'min',
      timeTypes: [
        {
          name: '分',
          value: 'min'
        },
        {
          name: '时',
          value: 'hour'
        },
        {
          name: '天',
          value: 'day'
        },
        {
          name: '月',
          value: 'month'
        }
      ],
      dialogFormVisible: false,
      formLabelWidth: '90px',
      index: '',
      arealist: [],
      currentPage: 1,
      timeValue: '',
      type: '',
      sort: '',
      word: '',
      brandId: '',
      typeId: '',
      areaId: '',
      devName: '',
      devCode: '',
      // devWifi: '',
      dialogFormType: 1,
      choseAll: false,
      choseDev: [],
      DeviceType: null,
      startTime: '',
      endTime: '',
      fcode: ''
    }
  },
  created () {
    this.watchRoute()
    this.getLei()
    this.currentPage = this.$session.get('page') ? this.$session.get('page') : 1
    // 获取项目设备列表
    this.getProDev()
    // 获取地区列表
    this.getAList()
    this.word = this.whitchArea
  },
  mounted () {
    var self = this
    self.updateTable()
    window.onresize = function () {
      self.updateTable()
    }
  },
  methods: {
    dobind (code) {
      var data = {
        account: window.localStorage.getItem('account'),
        dcode: code,
        fcode: this.fcode,
        token: window.localStorage.getItem('token'),
        ts: stringTime(this.$myTime()),
        type: 1
      }
      this.$http.post('https://www.airdaas.com/api/xf/dobind', requestData(data)).then(res => {
        if (res.data.data === 'success') {
          this.$message({
            message: '绑定成功',
            type: 'success'
          })
        }
      })
    },
    qwer () {
      this.choseAll = !this.choseAll
      this.choseDev = []
    },
    downOne (item) {
      this.choseDev = []
      this.choseDev.push(item)
      this.dataDown = true
      // this.down(item.code)
    },
    downloadall () {
      var arr = []
      this.choseDev.forEach(item => {
        arr.push(item.code)
      })
      var code = arr.join(',')
      this.down(code)
    },
    // 获取设备类型
    getLei () {
      var time = stringTime(this.$myTime())
      var data = {
        account: window.localStorage.getItem('account'),
        token: window.localStorage.getItem('token'),
        ts: time
      }
      this.getDeviceType(requestData(data)).then(res => {
        this.DeviceType = res
      })
    },
    // 批量下载
    d () {
      if (!this.choseDev.length) {
        this.$message({
          message: this.$store.state.module1.isChina ? '请先选择设备' : 'select devices',
          type: 'warning'
        })
        return
      }
      this.dataDown = true
    },
    down (code) {
      var time = stringTime(this.$myTime())
      var data = {
        account: window.localStorage.getItem('account'),
        codes: code,
        datetype: this.timeType,
        max_time: stringTime(this.endTime),
        min_time: stringTime(this.startTime),
        token: window.localStorage.getItem('token'),
        ts: time
      }
      this.checklog(requestData(data)).then(res => {
        window.open(res)
      }).catch(rea => {
        this.$message({
          message: rea.message,
          type: 'warning'
        })
      })
    },
    // 清空选项
    toggleSelection () {
      this.$refs.multipleTable.clearSelection()
    },
    // 批量操作
    handleSelection (val) {
      console.log(val)
      this.choseDev = val
    },
    // 添加设备
    addDev (e) {
      if (this.devCode && this.devName && this.areaId) {
        this.dialogFormVisible = false
        var data
        if (this.dialogFormType === 1) { // 添加设备
          data = {
            account: window.localStorage.getItem('account'),
            area_id: parseInt(this.areaId),
            code: this.devCode,
            dname: this.devName,
            sort: this.sort,
            token: window.localStorage.getItem('token'),
            ts: stringTime(this.$myTime()),
            type: parseInt(this.typeId.id)
            // wifi_address: this.devWifi
          }
          this.addDevice(requestData(data)).then(res => {
            this.$message({
              message: this.$store.state.module1.isChina ? '添加成功' : 'success',
              type: 'success'
            })
          })
        } else { // 修改设备
          data = {
            account: window.localStorage.getItem('account'),
            area_id: parseInt(this.areaId),
            code: this.devCode,
            dname: this.devName,
            sort: this.sort,
            token: window.localStorage.getItem('token'),
            ts: stringTime(this.$myTime()),
            type: parseInt(this.typeId.id)
            // wifi_address: this.devWifi
          }
          this.editDevice(requestData(data)).then(res => {
            this.$message({
              message: this.$store.state.module1.isChina ? '修改成功' : 'success',
              type: 'success'
            })
          })
        }
      } else {
        this.$message({
          message: this.$store.state.module1.isChina ? '请填写完成的信息' : 'Incomplete information',
          type: 'warning'
        })
      }
    },
    // 更新表格
    updateTable () {
      var oWidth1 = document.body.clientWidth || document.documentElement.clientWidth
      this.width = 140 / 1496 * oWidth1
    },
    // 打开添加按钮
    openAddDev () {
      this.dialogFormVisible = true
      this.dialogFormType = 1
    },
    // 获取项目设备列表函数------------------------
    getProDev () {
      var time = stringTime(this.$myTime())
      var data = {
        account: window.localStorage.getItem('account'),
        limit: 8,
        page: this.currentPage,
        project_id: window.localStorage.getItem('proId'),
        token: window.localStorage.getItem('token'),
        ts: time
      }
      this.getProjectDev(requestData(data))
    },
    // 页面跳转
    changePage (index) {
      this.$session.set('page', index)
      this.currentPage = index
      this.getProDev()
    },
    // 帅选关键词
    searchWord () {
      this.arealist = this.projectDev.filter(item => {
        return item.areaname.indexOf(this.word) !== -1
      })
    },
    // ------------------------------------接口
    getAList () {
      var time = stringTime(this.$myTime())
      var data = {
        account: window.localStorage.getItem('account'),
        limit: 99,
        project_id: window.localStorage.getItem('proId'),
        token: window.localStorage.getItem('token'),
        ts: time
      }
      this.getProAreaList(requestData(data))
    },
    // 删除设备
    deleteDe (dev) {
      this.$confirm(this.$store.state.module1.isChina ? '确定删除此此设备?' : 'Are you sure you want to delete?', this.$store.state.module1.isChina ? '提示' : 'Tips', {
        confirmButtonText: this.$store.state.module1.isChina ? '确定' : 'OK',
        cancelButtonText: this.$store.state.module1.isChina ? '取消' : 'Cancel',
        type: 'warning'
      }).then(() => {
        var time = stringTime(this.$myTime())
        var data = {
          account: window.localStorage.getItem('account'),
          code: dev.code,
          token: window.localStorage.getItem('token'),
          ts: time
        }
        this.delDevice(requestData(data)).then(res => {
          this.$message({
            message: this.$store.state.module1.isChina ? '删除成功' : 'success',
            type: 'success'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$store.state.module1.isChina ? '已取消删除' : 'Deletion canceled'
        })
      })
    },
    // 批量删除
    deleteAll () {
      if (!this.choseDev.length) {
        this.$message({
          message: this.$store.state.module1.isChina ? '请先选择设备' : 'select device',
          type: 'warning'
        })
        return
      }
      this.$confirm(this.$store.state.module1.isChina ? '确定删除此此设备?' : 'Are you sure you want to delete?', this.$store.state.module1.isChina ? '提示' : 'Tips', {
        confirmButtonText: this.$store.state.module1.isChina ? '确定' : 'OK',
        cancelButtonText: this.$store.state.module1.isChina ? '取消' : 'Cancel',
        type: 'warning'
      }).then(() => {
        var arr = []
        this.choseDev.forEach(item => {
          arr.push(item.code)
        })
        var code = arr.join(',')
        var time = stringTime(this.$myTime())
        var data = {
          account: window.localStorage.getItem('account'),
          code: code,
          token: window.localStorage.getItem('token'),
          ts: time
        }
        this.delDevice(requestData(data)).then(res => {
          this.$message({
            message: this.$store.state.module1.isChina ? '删除成功' : 'success',
            type: 'success'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$store.state.module1.isChina ? '已取消删除' : 'Deletion canceled'
        })
      })
    },
    // 编辑设备按钮
    editDev (dev) {
      this.dialogFormType = 2
      this.dialogFormVisible = true
      this.devName = dev.dname
      this.devCode = dev.code
      this.devWifi = dev.wifi_address
      this.brandId = parseInt(dev.devicebrand_id)
      this.DeviceType.forEach(item => {
        if (parseInt(item.id) === parseInt(dev.type)) {
          this.typeId = item
        }
      })
    },
    // 监听路由显示绑定
    watchRoute () {
      if (parseInt(this.$route.params.id) !== 0) {
        this.bindXf = true
        this.fcode = this.$route.params.id
      } else {
        this.bindXf = false
      }
    }
  },
  destoryed () {
    window.onload = null
    window.onresize = null
  },
  watch: {
    timeValue (value) { // 没问题ok
      this.$nextTick(() => {
        if (value) {
          this.startTime = new Date(value[0])
          this.endTime = new Date(new Date(value[1]).getTime() + 1000 * 60 * 60 * 24 - 1000)
          var difTime = this.endTime.getTime() - this.startTime.getTime()
          if (difTime > 30 * 24 * 60 * 60 * 1000) {
            this.$message({
              message: this.$store.state.module1.isChina ? '时间间隔不能超过30天' : 'The time interval cannot exceed 30 days',
              type: 'warning'
            })
          } else if ((this.endTime.getTime() - 1000 * 60 * 60 * 24) > this.$myTime().getTime()) {
            this.$message({
              message: this.$store.state.module1.isChina ? '时间不能超过当前时间' : 'The time cannot exceed the current time',
              type: 'warning'
            })
          }
        }
      })
    },
    projectDev (value) {
      this.$nextTick(() => {
        this.arealist = value
        if (this.word) {
          this.searchWord()
        }
      })
    },
    // 增加修改后刷新页面
    File (value) {
      this.$nextTick(() => {
        this.getProDev()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.manage-header{
    width:calc(100% + 0.48rem);
    height:1.76rem;
    transform:translate(-0.1rem,-0.1rem);
    background:white;
    box-shadow:inset 8px 8px 8px 2px rgba(0,0,0,0.04);
    text-align:left;
    padding-top:0.4rem;
    padding-left:0.4rem;
    h3{
        margin-bottom:0.2rem;
    }
    div:last-child{
        width:4rem;
        height:0.5rem;
        border:1px solid #ccc;
        border-radius:0.1rem;
        padding:0 0.2rem;
        line-height:0.5rem;
        display:flex;
        align-items:center;
        justify-content:space-between;
    }
    div:first-child{
      display:flex;
      align-items:baseline;
      span{
        color:#01A3FF;
        margin-left:0.2rem;
        font-weight:600;
        font-size:0.14rem;
      }
    }
}
.upDown{
transition: all 0.4s;
transform :rotate(90deg);
}
.devData{
  width:100%;
  height:100%;
}
.section6{
  height:calc(100% - 1.76rem);
  overflow:auto;
}
.section2{
  .qwe{
    text-align:center;
    font-size:0.12rem;
    position:relative;
    i{
      margin:0 0.1rem;
      font-size:0.18rem;
    }
    span{
      font-size:0.12rem;
      font-weight:100;
      margin-left:0.03rem;
      color:grey;
      opacity:0.8;
    }
  }
  .qa{
    font-weight:600;
    color:black;
  }
}

.myPage{
  margin-top:0.4rem;
}
  .mafan{
    font-size:0.16rem;
    margin:0 0.1rem;
  }
.choseAll{
  height:0.4rem;
  margin-top:0.2rem;
  width:100%;
  background:#E6F7FF;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:0 0.2rem;
  span{
    margin:0 0.1rem;
    color:#1890FF;
    cursor:pointer;
  }
  .have{
    color:black;
  }
  span:last-child{
    margin-right:0;
  }
}
</style>
